import { Select, css, styled } from "@mui/material";
import { MenuItem } from "../Menu";

export const StyledIconContainer = styled("div")`
  && {
    display: flex;
    align-items: flex-end;
    color: inherit;
  }
`;

export const StyledSelectContainer = styled(Select)<{
  selectSize: "big" | "medium";
}>`
  ${({ theme: { wsc }, value, selectSize }) => {
    return css`
      width: 100%;
      transition: all 0.3s linear;

      &.MuiInputBase-root {
        &&& .MuiInputBase-input {
          padding-right: 0;
        }

        .MuiSelect-icon {
          position: static;
        }

        cursor: pointer;
        color: ${value ? wsc.palette.primary[300] : wsc.palette.neutral[100]};
        padding: 0 ${wsc.spacing[0]};
        ${wsc.typography[selectSize === "big" ? "header3" : "header5"]};
        ::after,
        ::before {
          content: "";
          border-bottom: calc(${wsc.size.xs} / 2) solid
            ${wsc.palette.neutral[100]};
        }
        :hover {
          color: ${wsc.palette.primary[100]};
          ::after,
          ::before {
            border-color: ${wsc.palette.primary[100]};
          }
        }
      }

      &.Mui-disabled {
        color: ${wsc.palette.neutral[400]};
        pointer-events: none;

        &.MuiInputBase-root {
          ::after,
          ::before {
            content: "";
            border-bottom: calc(${wsc.size.xs} / 2) solid
              ${wsc.palette.neutral[400]};
          }

          .MuiSelect-select {
            -webkit-text-fill-color: unset;
          }

          .MuiSelect-icon {
            color: ${wsc.palette.neutral[400]};
          }
        }
      }
    `;
  }}
`;

export const StyledItem = styled(MenuItem)`
  ${({ theme: { wsc } }) => {
    return css`
      &.MuiButtonBase-root {
        display: flex;
        align-items: center;
        gap: ${wsc.spacing[1]};
        padding: ${wsc.spacing[1]} ${wsc.spacing[2]};
        color: ${wsc.palette.neutral[100]};
        :hover {
          background-color: ${wsc.palette.neutral[600]};
        }
        &.Mui-selected {
          background-color: ${wsc.palette.neutral[500]};
        }
      }
    `;
  }}
`;
export const StyledLabel = styled("div")`
  ${({ theme: { wsc } }) => {
    return css`
      && {
        color: ${wsc.palette.neutral[300]};
        margin-bottom: ${wsc.spacing[1]};
        padding: 0 ${wsc.spacing[2]};
      }
    `;
  }}
`;

export const StyledMenu = styled("div")`
  ${({ theme: { wsc } }) => {
    return css`
      && {
        margin-top: ${wsc.spacing[2]};
      }
    `;
  }}
`;

export const StyledPaper = styled("div")`
  ${({ theme: { wsc } }) => {
    return css`
      && {
        border-radius: ${wsc.radius.m};
        background-color: ${wsc.palette.neutral[700]};
      }
    `;
  }}
`;

export const StyledMenuList = styled("div")`
  ${({ theme: { wsc } }) => {
    return css`
      && {
        background-color: ${wsc.palette.neutral[700]};
      }
    `;
  }}
`;
